import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { CreatorFeatureInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { ImageField } from './ImageField'
import { ResourceSelectField } from './ResourceSelectField'

export const CreatorFeatureForm: FC<FormProps<Partial<CreatorFeatureInput>>> =
  flowMax(
    addDisplayName('CreatorFeatureForm'),
    addTranslationHelpers,
    ({ values, onChange, errors, t }) => (
      <div>
        <ResourceSelectField
          id="userId"
          label={t('admin.resources.media.fields.user')}
          error={errors.userId}
          resourceName="users"
          selectedId={values.userId}
          onChange={(creatorId) => onChange({ ...values, userId: creatorId })}
          focusOnMount
        />
        <ImageField
          id="imageId"
          label={t('admin.resources.creatorFeatures.fields.imageId')}
          value={values.imageId}
          onChange={(imageId) => onChange({ ...values, imageId })}
          error={errors.imageId}
        />
      </div>
    )
  )
